import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createUserEndorsementReportSlice = (set, get) => ({
    userEndorsementReport: {
        loading: false,
        data: []
    },
    // گزارش الحاقیه‌های یک کاربر خاص (ادمین) — /v1/crm/endorsement-report/user/{userId}
    getUserEndorsementReport: async (userId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ userEndorsementReport: { ...state.userEndorsementReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/crm/endorsement-report/user/${userId}`,
                headers: { token }
            });
            set(state => ({ userEndorsementReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ userEndorsementReport: { loading: false, data: [] } }));
        }
    },
    // الحاقیه‌های کاربر جاری — /v1/user/endorsement
    getUserEndorsements: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ userEndorsementReport: { ...state.userEndorsementReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/user/endorsement`,
                headers: { token }
            });
            set(state => ({ userEndorsementReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ userEndorsementReport: { loading: false, data: [] } }));
        }
    }
});
